import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	descriptionNonFinal: {
		id: 'eoc-changeboarding.common.feedback-collector-description.description-non-final',
		defaultMessage: 'Your thoughts are valuable in helping improve our products.',
		description: 'Feedback modal description',
	},
	learnMoreNonFinal: {
		id: 'eoc-changeboarding.common.feedback-collector-description.learn-more-non-final',
		defaultMessage:
			"If you're looking to get help or want to report a bug, visit our <link>support site</link>.",
		description: 'Feedback modal learn more text',
	},
});
